import { sanitizeLetterHtml } from "./htmlUtils.ts";

export type ClientLetterInsert = {
  user_id: string;
  email: string;
  whatsapp: string | null;
  content: string;
  delivery_date: string;
};

export type OwnProfileInsert = {
  id: string;
  email: string;
};

export type OwnProfileUpdate = {
  whatsapp: string;
};

const BLOCKED_LETTER_FIELDS = ["payment_status", "plan_type", "stripe_session_id", "sent"] as const;
const BLOCKED_PROFILE_FIELDS = ["role", "plan_type"] as const;

export function buildClientLetterInsert(input: {
  userId: string;
  email: string;
  whatsapp?: string | null;
  content: string;
  deliveryDate: string;
}): ClientLetterInsert {
  const whatsapp = input.whatsapp?.trim() ?? "";
  return {
    user_id: input.userId,
    email: input.email.trim(),
    whatsapp: whatsapp ? whatsapp : null,
    content: sanitizeLetterHtml(input.content),
    delivery_date: input.deliveryDate,
  };
}

export function buildOwnProfileInsert(input: { id: string; email: string }): OwnProfileInsert {
  return {
    id: input.id,
    email: input.email,
  };
}

export function buildOwnProfileUpdate(whatsapp: string): OwnProfileUpdate {
  return { whatsapp };
}

export function payloadOmitsBlockedFields(
  payload: object,
  fields: readonly string[] = [...BLOCKED_LETTER_FIELDS, ...BLOCKED_PROFILE_FIELDS],
): boolean {
  return fields.every((field) => !Object.prototype.hasOwnProperty.call(payload, field));
}

export function letterInsertOmitsPaymentControls(payload: ClientLetterInsert): boolean {
  const serialized = JSON.stringify(payload);
  return payloadOmitsBlockedFields(payload, BLOCKED_LETTER_FIELDS) && !serialized.includes("paid");
}

/** A reconciliação de pagamento é de operador. O browser não a invoca. */
export function browserMayInvokeVerifyLetterPayments(): false {
  return false;
}

/** Recusa promover o próprio usuário. O único caminho de JWT é admin_set_user_role. */
export function refuseSelfRolePromotion(actorId: string, targetId: string): boolean {
  return actorId.length > 0 && actorId === targetId;
}
